<template>
  <main class="login">
    <section>
      <div class="branding">
        <figure class="logo" alt="PTC Wizard Logo">
          <Logo />
        </figure>
        <div class="school-name">School Name</div>
      </div>
      <div class="card" v-if="verification">
        <h4 class="card-header">Email Verification Successful</h4>
        <div class="card-body">
          <p>You may now begin using PTC Wizard.</p>
          <button class="submit mt-5" @click="verification = !verification">
            <span>Continue</span>
          </button>
        </div>
      </div>
      <div class="card" v-else>
        <h4 class="card-header">Email Verification Failed</h4>
        <div class="card-body">
          <p>[reason for failure].</p>
          <p>Please try again or contact your school for help at [School Contact Info].</p>
        </div>
        <div class="card-footer">
          <router-link class="btn btn-link" to="/logout">
            <i class="bi bi-arrow-left me-2 opacity-50"></i><span>Return to Sign In</span>
          </router-link>
        </div>
      </div>
      <small class="text-muted vstack gap-1">
        <strong class="opacity-50">Parent Teacher Conference Scheduling Made Easy</strong>
        <div>&copy;2006 - {{ new Date().getFullYear() }} PTC Wizard, All rights reserved.</div>
      </small>
    </section>
  </main>
</template>

<script setup>
import { ref } from "vue";
import Logo from "@/assets/icons/logo-vertical-regular.svg";
const verification = ref(true);
</script>
